import type { CharacterCreationFlow, EntityTemplate, SceneHeaderTemplate } from "./templates";

export const defaultCharacterTemplate: EntityTemplate = {
  id: "character:free-fiction:v1",
  kind: "character",
  version: 1,
  name: "Free Fiction Character",
  fields: [
    { id: "displayName", label: "ชื่อ", type: "text", required: true, contextPriority: "always" },
    { id: "epithet", label: "ฉายา", type: "text", contextPriority: "active" },
    { id: "appearance", label: "รูปลักษณ์", type: "long_text", contextPriority: "active" },
    { id: "personality", label: "บุคลิก", type: "long_text", contextPriority: "active" },
    { id: "innerDrive", label: "แรงขับภายใน", type: "long_text", contextPriority: "retrieved" },
    { id: "currentState", label: "สถานะปัจจุบัน", type: "text", contextPriority: "active" },
    { id: "conditions", label: "เงื่อนไขที่มีผล", type: "list", contextPriority: "active" },
    { id: "images", label: "ภาพตัวละคร", type: "list", item: { id: "image", label: "ภาพ", type: "image" }, contextPriority: "never" },
  ],
  layout: [
    { id: "hero", type: "image_header", binding: "images.0" },
    { id: "identity", type: "card", children: [{ id: "name", type: "text", binding: "displayName" }, { id: "epithet", type: "text", binding: "epithet" }] },
    { id: "profile-tabs", type: "tabs", children: [{ id: "appearance", type: "markdown", binding: "appearance" }, { id: "personality", type: "markdown", binding: "personality" }, { id: "drive", type: "markdown", binding: "innerDrive" }] },
    { id: "state", type: "condition_chips", binding: "conditions" },
    { id: "links", type: "reference_grid" },
  ],
  imagePolicy: { autoGenerateCover: false, maxAutoGeneratedImages: 1, maxUserImages: 10, stylePreset: "story" },
};

export const defaultSceneHeader: SceneHeaderTemplate = {
  id: "header:cinematic:v1",
  version: 1,
  themeToken: "forest-mint",
  layout: "cinematic",
  maxVisibleSlots: 3,
  calendarFormat: "{month} {day}, Year {year} · {time}",
  locationBinding: "activeLocation.title",
  slots: [
    { id: "time", label: "เวลา", emoji: "◷", colorToken: "mint", sourceBinding: "worldClock.time", priority: 100 },
    { id: "date", label: "วันที่", emoji: "◈", colorToken: "gold", sourceBinding: "worldClock.date", priority: 95 },
    { id: "weather", label: "อากาศ", emoji: "☂", colorToken: "cyan", sourceBinding: "worldClock.weather", priority: 90 },
    { id: "pressure", label: "แรงกดดัน", emoji: "△", colorToken: "rose", sourceBinding: "scene.activePressure", priority: 80 },
    { id: "condition", label: "สถานะ", emoji: "◇", colorToken: "violet", sourceBinding: "character.conditions.0", priority: 70 },
  ],
};

export const defaultCharacterCreationFlow: CharacterCreationFlow = {
  id: "creation:soul-record:v1",
  version: 1,
  title: "Soul Record",
  steps: [
    { id: "identity", title: "คุณอยากเป็นใครในโลกนี้?", kind: "long_text", resultBinding: "identitySeed", required: true },
    { id: "appearance", title: "คนแปลกหน้ามองเห็นอะไร?", kind: "long_text", resultBinding: "appearance", required: true },
    { id: "drive", title: "สิ่งใดผลักคุณให้ก้าวต่อ?", kind: "choice", resultBinding: "innerDrive", required: true },
    { id: "portrait", title: "เลือกภาพหรือให้ระบบเสนอหนึ่งภาพ", kind: "image", resultBinding: "images.0" },
    { id: "review", title: "ตรวจสอบ Soul Record", kind: "review", resultBinding: "review" },
  ],
};
